import { FormListItem } from '../types';
import { FormListItemApi } from '../types/formListApi';

export const mapFormListItemToApi = (item: FormListItem): FormListItemApi => ({
  id: item.id,
  name: item.name,
  add_to_mode: item.addTo.mode,
  group:
    item.addTo.groupId && item.addTo.groupName
      ? { id: item.addTo.groupId, name: item.addTo.groupName }
      : null,
  viewed_count: item.viewCount,
  paid_count: item.registrationCount,
  conversion_rate: item.conversionRate,
  status: item.status,
  created_at: item.lastEdited,
  updated_at: item.lastEdited,
  is_source_tracking_enabled: item.sourceTrackingEnabled,
  form_link: item.publicUrl
});

export default mapFormListItemToApi;
